import {Action, Store} from 'redux';

import {LOAD_PROFILE_DATA} from 'ducks/Profile';
import {getParty, getAccountNumbers} from 'selectors/Profile';
import {ensighten} from 'shared/Ensighten/components';
import {EnsightenActionResult} from 'shared/Ensighten/types';
import {diffInYears} from 'utils/date-time';
import {packFailure, packSuccess} from 'utils/redux-pack';

const analyticsMiddleware = (store: Store) => (next: (action: Action) => object) => (action: Action) => {
  function sendEnsightenMessage(actionType: string, operationResult: EnsightenActionResult) {
    const message = {
      messageID: 'Message',
      messageType: operationResult,
      messageDescription: actionType + ' ' + operationResult
    };
    ensighten.addMessage(message);
  }

  const result = next(action);
  const newState = store.getState();

  if (packSuccess(action, LOAD_PROFILE_DATA)) {
    const party = getParty(newState);
    const accountNumbers = getAccountNumbers(newState);

    if (party) {
      const dateOfBirth = party.dateOfBirth;
      const userAge = dateOfBirth ? diffInYears(Date.now(), new Date(dateOfBirth)) : 0;
      ensighten.setProfileData({
        username: party.webIdentity?.userId,
        age: userAge,
        accounts: accountNumbers.map((account) => ({amicaNumber: account}))
      });
    }
  }

  /**
   * Success or Failure for EVERY action will be sent to ensighten
   * EXCEPT if the action is in the ignore array
   */
  const ensightenStandardMessageOptOut = [LOAD_PROFILE_DATA];

  if (!ensightenStandardMessageOptOut.includes(action.type)) {
    if (packSuccess(action, action.type)) {
      sendEnsightenMessage(action.type, EnsightenActionResult.SUCCESSFUL);
    } else if (packFailure(action, action.type)) {
      sendEnsightenMessage(action.type, EnsightenActionResult.UNSUCCESSFUL);
    }
  }

  return result;
};

export default analyticsMiddleware;
